import { Button } from '@/components/ui/button';
import { Menu01, X } from '@untitled-ui/icons-react';
import { useTranslation } from 'react-i18next';

interface Props {
  isOpen: boolean;
  onClick: () => void;
}

export const Hamburger = ({ isOpen, onClick }: Props) => {
  const { t } = useTranslation();
  return (
    <div className="md:hidden h-full flex items-center justify-end">
      <Button
        variant="ghost"
        className="p-0 size-12 z-50 flex items-center justify-center rounded-md border-2 border-bd-primary"
        onClick={onClick}
        aria-label={
          isOpen
            ? t('translation:accessibility.button.hamburger_close')
            : t('translation:accessibility.button.hamburger_open')
        }
      >
        {isOpen ? <X className="size-8 text-white" /> : <Menu01 className="size-7 text-white" />}
      </Button>
    </div>
  );
};
